import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const AddSEO: React.FC = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    page_url: "",
    meta_title: "",
    meta_description: "",
    meta_keywords: "",
  });
  const [loading, setLoading] = useState(false);

  // ✅ Base URL from .env
  const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "http://localhost:4000/api/v1";

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/seo`, formData);
      alert("✅ SEO added successfully!");
      navigate("/settings/seo");
    } catch (err) {
      console.error("Error adding SEO:", err);
      alert("❌ Failed to add SEO!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-container container-fluid">
      <div className="page-header">
        <h1 className="page-title">Add SEO</h1>
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a href="/">Home</a></li>
          <li className="breadcrumb-item active">Add SEO</li>
        </ol>
      </div>

      <div className="row">
        <div className="col-xl-12 col-md-12">
          <form className="card" onSubmit={handleSubmit}>
            <div className="card-body">
              <div className="form-group">
                <label className="form-label">Page URL</label>
                <input
                  type="text"
                  className="form-control"
                  name="page_url"
                  value={formData.page_url}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Meta Title</label>
                <input
                  type="text"
                  className="form-control"
                  name="meta_title"
                  value={formData.meta_title}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Meta Description</label>
                <textarea
                  className="form-control"
                  name="meta_description"
                  value={formData.meta_description}
                  onChange={handleChange}
                ></textarea>
              </div>

              <div className="form-group">
                <label className="form-label">Meta Keywords</label>
                <textarea
                  className="form-control"
                  name="meta_keywords"
                  value={formData.meta_keywords}
                  onChange={handleChange}
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddSEO;

